import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { InfoIcon } from 'ui-components/components/info-icon';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { messages } from './messages';

const PackageContentDescriptionInfoIcon = ({ className, tooltipPosition }) => {
  return (
    <FormattedMessage {...messages.reasonForField}>
      {(formattedMessage) => (
        <InfoIcon className={className} color={THEME_CONSTANTS.unstyled} position={tooltipPosition} tooltipText={formattedMessage} />
      )}
    </FormattedMessage>
  );
};

PackageContentDescriptionInfoIcon.propTypes = {
  className: PropTypes.string,
  tooltipPosition: PropTypes.string,
};

export { PackageContentDescriptionInfoIcon };
